<template>
  <svg
    data-testid="check-circle-filled-icon"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9998 43.8884C34.9834 43.8884 43.8874 34.9844 43.8874 24.0008C43.8874 13.0172 34.9834 4.11328 23.9998 4.11328C13.0163 4.11328 4.1123 13.0172 4.1123 24.0008C4.1123 34.9844 13.0163 43.8884 23.9998 43.8884Z"
      fill="white"
    />
    <path
      d="M24 0C10.7487 0 0 10.754 0 24C0 37.246 10.754 48 24 48C37.246 48 48 37.246 48 24C48 10.754 37.246 0 24 0ZM17.4966 34.2971L8.87846 25.679C7.94332 24.7439 7.94332 23.2296 8.87846 22.2944C9.81359 21.3593 11.3279 21.3593 12.263 22.2944L19.2021 29.207L35.7157 12.6934C36.6509 11.7583 38.1652 11.7583 39.1003 12.6934C40.0354 13.6285 40.0354 15.1428 39.1003 16.0779L20.8811 34.2971C19.9672 35.2322 18.4317 35.2322 17.4966 34.2971Z"
      fill="url(#paint0_linear_2857_9533)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2857_9533"
        x1="33.2516"
        y1="65.1763"
        x2="-7.5656"
        y2="56.1322"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#01B88E" />
        <stop offset="0.94" stop-color="#86DBC8" />
      </linearGradient>
    </defs>
  </svg>
</template>
